import { Link as AkselLink } from '@navikt/ds-react'
import styles from './LinkButton.module.css'

type LinkButtonProps = {
    children: React.ReactNode
    onClick: () => void
    className?: string
    'aria-label'?: string
}

// Brukes der en kontroll ser ut som en lenke, men bare endrer tilstand i appen og derfor må være en knapp.
export function LinkButton({ children, className, ...rest }: LinkButtonProps) {
    return (
        <AkselLink as="button" type="button" className={[styles.linkButton, className].filter(Boolean).join(' ')} {...rest}>
            {children}
        </AkselLink>
    )
}
